import styled, { css } from 'styled-components';
import { media } from 'app/styles/variables';
import { generateFontSizing } from 'app/styles/mixins';
import { IconWrapper } from 'app/shared/components/IconWrapper/IconWrapper';
import { NonGutterAbsolutElementSt } from 'app/shared/components/ModelReview/ModelReview.css';

export const ModelSpecificBackgroundSt = styled(NonGutterAbsolutElementSt)`
  bottom: 0;
  height: calc(100% - 2.5rem);
  background-color: ${({ theme }) => theme.colors.secondary100};
  z-index: -1;
`;

export const ModelSpecificContainerSt = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0;
  ${media.md(css`
    display: grid;
    grid-template-columns: minmax(0, 6fr) minmax(0, 4fr);
  `)}
  padding-bottom: 2.5rem;
`;

export const ModelSpecificImageContainerSt = styled.div``;

export const ModelSpecificDetailsContentSt = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  ${media.sm(css`
    flex-direction: row;
    gap: 1rem;
    justify-content: space-around;
  `)}

  ${media.md(css`
    flex-direction: column;
    gap: 0.5rem;
  `)}
`;

export const SearchQueryButtonWrapperSt = styled.div`
  margin-top: 2rem;

  a {
    width: 100%;

    ${media.sm(css`
      width: 50%;
    `)}
    ${media.md(css`
      width: 100%;
    `)}

    button {
      width: 100%;
    }
  }

  ${media.md(css`
    margin-top: auto;
  `)}
`;

export const ModelSpecificDetailsContainerSt = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 1rem;

  ${media.md(css`
    display: flex;
    flex-direction: column;
    position: relative;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  `)}
`;

export const ModelSpecificDetailsTitleSt = styled.h3`
  margin: 1.5rem 0;
  ${generateFontSizing('h3')}
  color: ${({ theme }) => theme.colors.neutral800};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  ${media.md(css`
    margin-top: 1rem;
  `)}
`;

export const ModelSpecificDetailsGridSt = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;
  gap: 0.5rem;
`;

export const ModelSpecificDetailsLabelSt = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  word-break: break-word;
`;

export const ModelSpecificDetailsTextSt = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  text-align: right;
  font-size: 0.875rem;
  word-break: break-word;
`;

export const IconWrapperSt = styled(IconWrapper)`
  margin-right: 0.75rem;
`;
